import { siteStats } from "@/mocks/fanCommunity";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=Energetic%20concert%20stage%20backdrop%20in%20coral%20pink%20and%20warm%20cream%20tones%2C%20dreamy%20soft%20bokeh%20stage%20lights%20in%20peach%20and%20gold%2C%20floating%20confetti%20and%20glitter%20particles%2C%20youthful%20playful%20celebrity%20fan%20atmosphere%2C%20smooth%20gradient%20lighting%2C%20editorial%20high%20detail&width=1600&height=1000&seq=hero-stage-2026&orientation=landscape";

export default function Hero() {
  return (
    <section id="home" className="relative flex w-full flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="吃瓜捷克粉丝应援舞台与暖色灯光背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/80" />
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-4 md:px-6 pt-28 md:pt-36 pb-10">
        <div className="flex max-w-2xl flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
            <i className="ri-heart-3-fill text-primary-200" />
            超话 · 后援会 · 应援 · 周边 · 见面会
          </span>
          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-bold leading-tight tracking-tight text-background-50">
            吃瓜捷克
            <span className="block mt-2 text-2xl md:text-4xl font-semibold text-background-100/90">
              粉丝聚集地，在这里与同好相遇
            </span>
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-background-100/85">
            这里汇聚超话签到、后援会分站、应援企划、周边资讯与见面会动态。想第一时间加入吃瓜捷克粉丝社群，或了解最新应援安排，从这里开始刚刚好。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#join"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm md:text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-team-line text-base" />
              加入粉丝社群
            </a>
            <a
              href="#support"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-full bg-white/15 px-6 py-3 text-sm md:text-base font-semibold text-background-50 backdrop-blur transition-colors hover:bg-white/25"
            >
              看看应援现场
              <i className="ri-arrow-down-line text-base" />
            </a>
          </div>
        </div>
      </div>

      {/* stats */}
      <div className="relative border-t border-white/15">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-6 px-4 md:px-6 py-8 md:grid-cols-4 md:gap-8">
          {siteStats.map((s) => (
            <div key={s.label} className="flex items-center gap-3">
              <span className="flex h-11 w-11 md:h-12 md:w-12 shrink-0 items-center justify-center rounded-xl bg-white/10 text-primary-200 backdrop-blur">
                <i className={`${s.icon} text-xl md:text-2xl`} />
              </span>
              <div className="flex flex-col">
                <span className="font-heading text-2xl md:text-3xl font-bold text-background-50">{s.value}</span>
                <span className="text-xs md:text-sm text-background-100/75">{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}